<template>
  <div>
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :on-cancel="onCancel"
    :is-full-page="fullPage"></loading>

    <h1>Lagerverlauf</h1>

    <div class="card">
      <div class="card-body">
        
        <BaseFilteringComponent></BaseFilteringComponent>

        <div class="form-group row">
          <div class="col-md-3">
            EAN: <input type="number" v-model="filterEAN" class="form-control form-control-sm">  
          </div>

          <div class="col-md-3">
            SKU: <input type="text" v-model="filterSKU" class="form-control form-control-sm"> 
          </div>

        </div>
        <div class="row">
          <div class="col-md-3">
            <button class="btn btn-sm btn-primary" v-on:click="fetchData">
              <font-awesome-icon icon="sync" />
              Anzeigen
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <a @click="downloadCSV" class="btn btn-primary btn-sm" style="margin-top: 10px; margin-bottom: 10px">
      <font-awesome-icon icon="download" />
      CSV Download
    </a>

    <table class="table table-bordered table-striped table-hover table-small" style="margin-top: 15px">
      <thead>
        <tr>
          <th>#</th>
          <th>Datum</th>
          <th>Lager</th>
          <th>EAN</th>
          <th>SKU</th>
          <th>Bezeichnung</th>
          <th>Typ</th>
          <th>Menge</th>
          <th>Alter Lagerb.</th>
          <th>Neuer Lagerb.</th>
          <th>EK</th>
          <th>Kommentar</th>
          <th>BestellNr</th>
        </tr>
      </thead>
      <tbody>
        <StockHistoryRow v-for="item in historyEntries" :item="item" :key="item.id"></StockHistoryRow>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'
const request = require('superagent')
import StockHistoryRow from './StockHistoryRow'
import Loading from 'vue-loading-overlay';
import BaseFilteringComponent from '@/components/BaseFilteringComponent';
import FileSaver from 'file-saver';

export default {
  name: 'StockHistory',
  data () { 
    // default is the current month
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

    firstDay = require('moment')(firstDay).format('YYYY-MM-DD')
    lastDay = require('moment')(lastDay).format('YYYY-MM-DD')

    return {
      filterSKU: "",
      filterEAN: "",
      historyEntries: [],
      from_date: firstDay,
      to_date: lastDay,
      isLoading: false,
      fullPage: true
    }
  },
  components: {
    'StockHistoryRow': StockHistoryRow,
    Loading,
    'BaseFilteringComponent': BaseFilteringComponent,
  },
  computed: {
    shopListing: function(){
      return this.$store.state.shops;
    },
    filterShopId(){
        return this.$store.state.filter_shop_id;
    },
    filterFromDate(){
        return this.$store.state.filter_from_date;
    },
    filterToDate(){
        return this.$store.state.filter_to_date;
    },
    currentUser: function(){
      return this.$store.state.current_user
    },
    downloadUrl: function(){
      var url = this.baseUrl+"&format=csv";
      return url;
    },
    baseUrl(){
      var url = process.env.API_HOST + '/api/stocks/movement?filter_sku='+this.filterSKU+"&filter_ean="+this.filterEAN+"&filter_from_date="+this.filterFromDate+"&filter_to_date="+this.filterToDate;
      if(this.currentUser.master == 1 && this.filterShopId != null && parseInt(this.filterShopId) != 0){
        url = url + "&filter_shop_ids="+ this.filterShopId;
      }
      return url;
    }
  },
  mounted(){
    
  },
  methods: {
    downloadCSV(){
      var that = this
      request
        .get(this.downloadUrl)
        .set('Authorization',localStorage.getItem('API_TOKEN'))
        .then(function (res) {
          var blob = new Blob(["\uFEFF"  + res.text], {type: "text/comma-separated-values;charset=utf-8"});

          FileSaver.saveAs(blob, "lagerverlauf.csv",{ autoBom: true});
        })

    },
    fetchData(){
      this.isLoading = true

      var that = this;
      var url = this.baseUrl

      var that = this
      request
        .get(url)
        .set('Accept', 'application/json')
        .set("Authorization",localStorage.getItem('API_TOKEN'))
        .then(function (res) {
          that.historyEntries = res.body.data
          that.isLoading = false
        })
    }, // end of fetchData
    onCancel(){}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/StockHistory.vue